import type { DataTableColumn } from '@/components/custom/erp';
import type { QuocGia } from '@/types/schemas';

export const getDataTableColumns = (): DataTableColumn<QuocGia>[] => {
  return [
    {
      field: 'ma_qg',
      headerName: 'Mã quốc gia',
      width: 150,
      editable: false
    },
    {
      field: 'ten_qg',
      headerName: 'Tên quốc gia',
      width: 200,
      flex: 1,
      editable: false
    }
  ];
};
